const formatPhoneNumber = (number) => {
   return number;

    // const phoneRegexp = /\+1 (\(\d{3}\)) (\d{3})-(\d{4})/;
    
    // skip if already in good foramt or an empty string
    // if (phoneRegexp.test(number) || "") {
    //     return number;
    // }

    // const countryCode = number.slice(0, 2);
    // const areaCode = number.slice(2, 5);
    // const threeDigits = number.slice(5, 8);
    // const fourDigits = number.slice(8, 12);
    // return `${countryCode} (${areaCode}) ${threeDigits}-${fourDigits}`;
};

export default formatPhoneNumber;
